import { PolygonModel } from "./polygon.model";

export class PolygonList {
    public polygons: PolygonModel[];

    constructor(value: JSON) {
        if(value["content"]) {
            this.polygons = [];
            for(const polygon of value["content"]) {
                this.polygons.push(new PolygonModel(polygon));
            }
        }
    }
}